import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite'
import {Link, useParams} from 'react-router'
import clubStore from '../../../storage/ClubStore'
import appStore from '../../../storage/AppStore'
import Btn from '../../../ui/Btn'
import MemberModal from './MemberModal'
import NoResult from "../../NoResult/NoResult";

const ShowTeam = () => {
    const args = useParams();
    useEffect(() => {
        clubStore.getTeam(args.id)
    }, [args.id]);
    return (
        <div className="row justify-content-center">
            <div className="flex flex-row w-100 justify-content-between px-3 my-2">
                <div className="flex align-items-center">
                    <b className="card-header">{clubStore.team.sport.icon} {clubStore.team.name}</b>
                </div>
                <div className="flex align-items-center">
                    <MemberModal/>
                </div>
            </div>
            {clubStore.team.members.length === 0 && <NoResult/>}
            <div className="table-responsive">
                <table className="table table-striped">
                    <tbody>
                    {clubStore.team.members.map((member, index) => (
                        <tr key={index}>
                            <td>{member.company_user.role_id === 'TRN' ? <b>{member.company_user.title}</b> :
                                <span>{member.company_user.title} #{member.company_user.forma_number} ({member.company_user.year_born})</span>}</td>
                            <td>
                                <Btn
                                    className={"btn btn-sm btn-danger"}
                                    onClick={() => {
                                        if (confirm(appStore.tr.are_you_sure_delete)) {
                                            clubStore.deleteTeamMember(member.id)
                                        }
                                    }}>
                                    <i className="ci ci-user-x"/>
                                </Btn>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default observer(ShowTeam);